export default "__VITE_ASSET__Cyw86mcn__"